import React, { useState } from 'react';
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import com_logo from "../../Home/Home_modules/Im/com_logo.png";
import "./navbar.css";
import Mobilemenu from './Mobile-menu'
import Publicmenu from '../../Components/publicmenu';
import LoggedinMenu from '../../Components/loggedinmenu';
import { Component } from 'react';
import firebase from 'firebase/compat/app';
import { getAuth } from "firebase/auth";


class Navbar extends Component{

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            isLoggedIn: false,
            redirect: false,
            redirectTo: null
        }
    }

    componentDidMount() {
        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.setState({ user: user, isLoggedIn: true });
            } else {
                this.setState({ user: null, isLoggedIn: false });
            }
        });
    }

render(){
    //const [isLoggedIn, setisLoggedIn] = useState(false);
    const isLoggedIn = this.state.isLoggedIn;

    if (isLoggedIn) {
        return (
            <div>
                <LoggedinMenu />
            </div>
        )
    } else {
        return (
            <div>
                <Publicmenu />
            </div>
        )

}
}
}
export default Navbar;